<template>
  <v-card height="100%" v-once>
    <v-card-title primary-title>
      <div class="headline">{{labels.driver}}</div>
    </v-card-title>
    <v-expansion-panel v-if="drivers.length > 0" class="elevation-0" v-model="panels" expand>
      <v-expansion-panel-content v-for="(driver,i) in drivers" :key="i">
        <div slot="header">
          <div class="body-2">
            {{driver.drvName}}
            <span v-if="i === 0 && applicant.appIntStat === 'I'">(Main Driver)</span>
          </div>
        </div>
        <v-card>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.drvName}}</v-subheader>
                  <div>{{driver.drvName}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.drvNricPassport}}</v-subheader>
                  <div>{{driver.drvNricPassport}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.drvExp}}</v-subheader>
                  <div>{{driver.drvExp}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.drvMarital}}</v-subheader>
                  <div>{{maritalStatus(driver.drvMarital)}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.drvGender}}</v-subheader>
                  <div>{{gender(driver.drvGender)}}</div>
                </v-flex>
                <v-flex xs6>
                  <v-subheader class="queryLabel">{{labels.drvDob}}</v-subheader>
                  <div>{{formatDisplayDate(driver.drvDob)}}</div>
                </v-flex>
                <v-flex xs6 v-if="$mode !== 'ecics'">
                  <v-subheader class="queryLabel">{{labels.drvOccupation}}</v-subheader>
                  <div>{{mtrOccupation(driver.drvOccupation)}}</div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card-text v-else>
      No Driver Details Available
    </v-card-text>
  </v-card>
</template>

<script>
import { maritalStatus, gender } from '@/const/underwriting'
import { mtrOccupation } from '@/const/underwriting/motor'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        driver: 'Driver',
        drvName: 'Name',
        drvNricPassport: 'NRIC/Passport',
        drvExp: 'Driving Experience',
        drvGender: 'Gender',
        drvOccupation: 'Occupation',
        drvMarital: 'Marital Status',
        drvDob: 'Date of Birth'
      },
      panels: []
    }
  },
  computed: {
    drivers() {
      return this.$store.state.agency.quotation.motorForm.drivers
    },
    applicant() {
      return this.$store.state.agency.quotation.commonForm.applicant
    }
  },
  methods: {
    maritalStatus(status) {
      return maritalStatus[status]
    },
    gender(xGender) {
      return gender[xGender]
    },
    mtrOccupation(occupation) {
      return mtrOccupation[occupation]
    },
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    }
  },
  created() {
    this.panels = []
    if (this.drivers && this.drivers.length > 0) {
      for (let i = 0; i < this.drivers.length; i++) {
        if (i === 0) {
          this.panels.push(true)
        } else {
          this.panels.push(false)
        }
      }
    }
  }
}
</script>

<style lang="scss">
</style>
